import { isHesbaHost } from '@/libs/appHost';

 export const initialAbility = [
  {
    action: 'read',
    subject: 'Auth',
  },
];

const useHesbaApi = isHesbaHost() && process.env.VUE_APP_HESBA_Base_Url;

export const domain = useHesbaApi ? process.env.VUE_APP_HESBA_Domain : process.env.VUE_APP_Domain // 'http://172.107.175.44:5050';
export const baseURL = useHesbaApi ? process.env.VUE_APP_HESBA_Base_Url : process.env.VUE_APP_Base_Url // `${domain}/api`; // 'http://localhost:59403/api/' // 'https://localhost:5001/api';
export const TOKEN_KEY = '@ACCESS_TOKEN';
export const PROFILE_KEY = '@USER_PROFILE';
export const LANG = '@LANG';
export const BRANCH_ID = '@BRANCH_ID';
export const CURRENT_YEAR = '@CURRENT_YEAR';
export const baseReportURL = useHesbaApi ? process.env.VUE_APP_HESBA_Base_Report_URL : process.env.VUE_APP_Base_Report_URL // 'http://172.107.175.44:5051/ReportViewer?' // 'http://localhost:51399/ReportViewer?' // 'http://198.12.95.197:5051/ReportViewer?'

export const _ = undefined;
